export default __webpack_public_path__ + "static/rings-24bc9d314b2bd4d42267684eecfdb939.png";